import { Component } from "@angular/core";
import { FirebaseAnalytics } from "@ionic-native/firebase-analytics";
import { NavController } from "ionic-angular";
import { PrivacyPolicyPage } from "../privacy-policy/privacy-policy";

@Component({
    selector: 'page-terms-and-conditions',
    templateUrl: 'terms-and-conditions.html'
})

export class TermsAndConditionsPage {

    constructor(
        public analytics: FirebaseAnalytics,
        private navCtrl: NavController,
    ) {

    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('TermsAndConditions');
    }

    public showPrivacyPolicy() {
        this.navCtrl.push(PrivacyPolicyPage);
    }

}



// WEBPACK FOOTER //
// ./src/pages/terms-and-conditions/terms-and-conditions.ts